export default __webpack_public_path__ + "static/media/mexc.9a693099.svg";